// import React from "react";
// import { Grid, Card, CardContent, Typography } from "@mui/material";
// import { DataGrid, GridColDef } from "@mui/x-data-grid";
// import { useForm } from "react-hook-form";
// import WSButton from "./Button/WSButton";
// import WSDateField from "./DateField/WSDateField";
// import DownloadIcon from "@mui/icons-material/Download";


// interface TemplateProps {
//   title: string;
//   columns: GridColDef[];
//   rows: any[];
//   onApply: (payload: any) => void;
//   children?: React.ReactNode;
// }

// export const ReportBaseTemplate: React.FC<TemplateProps> = ({
//   title,
//   columns,
//   rows,
//   onApply,
// }) => {
//   const { control, setValue, getValues } = useForm();

//   const handleApply = () => {
//     const payload = {
//       fromDate: getValues().fromDate,
//       to: getValues().to,
//     };
//     onApply(payload);
//   };

//   const handleDownload = () => {
//     const csvRows = [];

//     const headers = columns.map((col) => col.headerName);
//     csvRows.push(headers.join(","));

//     rows.forEach((row) => {
//       const values = columns.map((col) => row[col.field]);
//       csvRows.push(values.join(","));
//     });

//     const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.setAttribute("download", `${title}.csv`);
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   return (
//     <Grid container xs={12} md={12}>
//       <Grid item xs={12}>
//         <Card sx={{ m: 2 }}>
//           <CardContent>
//             <Grid container spacing={2} alignItems="center">
//               <Grid item xs={12} md={3}>
//                 <WSDateField
//                   id="fromDate"
//                   label="From Date"
//                   name="fromDate"
//                   control={control}
//                   setValue={setValue}
//                   dateFormat="YYYY-MM-DD"
//                   rules={{required:true}}
//                 />
//               </Grid>

//               <Grid item xs={12} md={3}>
//                 <WSDateField
//                   id="to"
//                   label="To Date"
//                   name="to"
//                   control={control}
//                   setValue={setValue}
//                   dateFormat="YYYY-MM-DD"
//                   rules={{required:true}}
//                 />
//               </Grid>

//               <Grid item xs={12} md={6} sx={{ display: "flex", gap: 2, alignItems: "center" }}>
//                 <WSButton id="applyFilterBtn" label="Apply Filter" size="small" onClick={handleApply} />
//               </Grid>
//             </Grid>
//           </CardContent>
//         </Card>
//       </Grid>

//       <Grid item xs={12}>
//   <Card sx={{ m: 2 }}>
//     <CardContent>

//       <Grid container alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
//         <Typography variant="h6">{title}</Typography>

//         <DownloadIcon 
//           onClick={handleDownload} 
//           style={{ cursor: "pointer", fontSize: "28px" }}
//         />
//       </Grid>

//       <div style={{ height: 420, width: "100%" }}>
//         <DataGrid
//           rows={rows}
//           columns={columns}
//           getRowId={(row) => row._id || row.id}
//           pageSizeOptions={[5, 10]}
//         />
//       </div>
      

//     </CardContent>
//   </Card>
// </Grid>

//     </Grid>
//   );
// };



import React from "react";
import { Grid, Card, CardContent, Typography } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useForm } from "react-hook-form";
import WSButton from "./Button/WSButton";
import WSDateField from "./DateField/WSDateField";
import DownloadIcon from "@mui/icons-material/Download";

interface TemplateProps {
  title: string;
  columns: GridColDef[];
  rows: any[];
  onApply: (payload: any) => void;
  children?: React.ReactNode;
}

export const ReportBaseTemplate: React.FC<TemplateProps> = ({
  title,
  columns,
  rows,
  onApply,
  children
}) => {

  const { control, setValue, getValues } = useForm();

  const handleApply = () => {
    const payload = {
      fromDate: getValues().fromDate,
      to: getValues().to,
    };
    onApply(payload);
  };

  const handleDownload = () => {
    const csvRows = [];
    const headers = columns.map((col) => col.headerName);
    csvRows.push(headers.join(","));
    rows.forEach((row) => {
      const values = columns.map((col) => row[col.field]);
      csvRows.push(values.join(","));
    });
    const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", `${title}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Grid container xs={12} md={12}>

      {/* FILTER CARD */}
      <Grid item xs={12}>
        <Card sx={{ m: 2 }}>
          <CardContent>
            <Grid container spacing={2} alignItems="center">

              <Grid item xs={12} md={3}>
                <WSDateField
                  id="fromDate"
                  label="From Date"
                  name="fromDate"
                  control={control}
                  setValue={setValue}
                  dateFormat="YYYY-MM-DD"
                  rules={{ required: true }}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <WSDateField
                  id="to"
                  label="To Date"
                  name="to"
                  control={control}
                  setValue={setValue}
                  dateFormat="YYYY-MM-DD"
                  rules={{ required: true }}
                />
              </Grid>

              <Grid item xs={12} md={6} sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                <WSButton id="applyFilterBtn" label="Apply Filter" size="small" onClick={handleApply} />
              </Grid>

            </Grid>
          </CardContent>
        </Card>
      </Grid>

      {/* CHILDREN REGION  (CUSTOM UI FROM PAGE LIKE CARDS / EXTRA TABLES) */}
      {children && (
        <Grid item xs={12} sx={{ px: 2 }}>
          {children}
        </Grid>
      )}

      {/* DEFAULT TABLE AREA (USED ONLY IF COLUMNS EXISTS) */}
      {columns.length > 0 && (
        <Grid item xs={12}>
          <Card sx={{ m: 2 }}>
            <CardContent>

              <Grid container alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
                <Typography variant="h6">{title}</Typography>
                <DownloadIcon onClick={handleDownload} style={{ cursor: "pointer", fontSize: "28px" }} />
              </Grid>

              <div style={{ height: 420, width: "100%" }}>
                <DataGrid
                  rows={rows}
                  columns={columns}
                  pagination
                  pageSizeOptions={[5, 10, 20]}
                  getRowId={(row) => row._id || row.id}
                />
              </div>

            </CardContent>
          </Card>
        </Grid>
      )}

    </Grid>
  );
};
